module.exports = __webpack_public_path__ + "static/img/5206_phase_function_Paper_Points.e030a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5206_phase_function_Paper_Points.png
// module id = m6Tn
// module chunks = 0